import yup from '../../../config/yup';

export const googleSpreadsheetReaderValidationSchema = yup.object().shape({
  '@id': yup.string(),
  name: yup
    .string()
    .matches(/^[a-zA-Z_$][a-zA-Z0-9_$]*$/, {
      message:
        'Name must start with a letter or underscore and can only contain letters, numbers, and underscores',
    })
    .required('Name is required'),
  type: yup.string().default('googleSpreadsheetReader'),
  delayedRead: yup.boolean(),
  parameterizedBy: yup.string(),
  format: yup.string(),
  connectionKey: yup.string(),
  properties: yup.object().shape({
    credential: yup.string(),
    spreadsheetId: yup.string().matches(/^[a-zA-Z0-9_-]+$/, {
      message: 'Spreadsheet ID must contain only letters, numbers, underscores, and hyphens',
    }),
  }),
});
